import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap";

@Component({
    moduleId: module.id,
    selector: 'angular-modal',
    templateUrl: 'angular-modal.html',
    styleUrls: ['angular-modal.css']
})
export class AngularModalComponent {
    @Input() Title: string = "";
    @Input() cancelButtonText: string = "Annulla";
    @Input() okButtonText: string = "OK";
    @Input() modalClass: string = "";
    @Input() modalHeaderClass: string = "";
    @Input() hideCancelButton: boolean = false;
    @Input() hideOkButton: boolean = false;
    @Input() autoClose: boolean = true;
    @Input() fromTop: number = 200;
    @Input() mywidth: string = "";

    @Output() okPressed = new EventEmitter();
    @Output() cancelPressed = new EventEmitter();

    @ViewChild('confirmModal') public confirmModal: ModalDirective;

    constructor() { }

    public show() {
        this.confirmModal.show();
    }

    public hide() {
        this.confirmModal.hide();
    }

    public ok() {
        this.okPressed.emit()
        if (this.autoClose) this.confirmModal.hide();
    }

    public cancel() {
        this.cancelPressed.emit();
        if (this.autoClose) this.confirmModal.hide();
    }

    onShown() {
        if (!document.body.classList.contains("modal-open")) document.body.classList.add("modal-open");
    }
    
    onHidden(){
        let modals = document.querySelectorAll(".modal-backdrop");
        if (modals.length == 0) document.body.classList.remove("modal-open");
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/modal/angular-modal.component.ts